import React from 'react';
import PropTypes from 'prop-types';

export default class TableHeader extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
          year: 0,
          categoryId:0
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
      const target = event.target;
      const name = target.name;

      let year = this.state.year;
      let categoryId = this.state.categoryId;

      console.log(year);
      console.log(target.value);

      if(name === 'year'){
        this.setState({year: target.value });
        year = target.value;
      } else {
        this.setState({categoryId: target.value });
        categoryId = target.value;
      }
      
      this.props.onChange(year, categoryId);
    }

    showCategory() {
 
        if(this.props.showCategory === false)
            return <label />
        else
            return <label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;カテゴリ：<select name="categoryId" value={this.state.categoryId} onChange={this.handleChange}>
                    <option value="0">全部</option>
                    <option value="1">グルメ</option>
                    <option value="2">ビューティー</option>
                    <option value="3">リラク&エステ</option>
                    <option value="4">ファッション</option>
                    <option value="11">生活・雑貨</option>
                    <option value="6">診察券</option>
                    <option value="5">スクール</option>
                    <option value="7">領収書</option>
                    <option value="8">身分証</option>
                    <option value="9">名刺</option>
                    <option value="10">その他</option>
                </select>
                </label>
    }

    render(){
        return (
        <div className="table-header col-sm-12">&nbsp;&nbsp;年度：
            <select name="year" value={this.state.year} onChange={this.handleChange}>
                <option value="0">全部</option>
                <option value="2018">2018</option>
                <option value="2017">2017</option>
                <option value="2016">2016</option>
            </select >
        
            {this.showCategory()}
        </div>);
    }
}

TableHeader.propTypes = {
    showCategory: PropTypes.bool,
    onChange: PropTypes.func.isRequired
}


// WEBPACK FOOTER //
// ./src/components/tables/TableHeader.jsx